export default {
  invoices: [],
  sitesSummaryReport: [],
  sitesSummaries: []
}
